
import { defineComponent, ref } from "vue";
import { useRouter } from "vue-router";

import i18n from "@/locales";
import { getImgUrl } from "@/helpers/getImage";

export default defineComponent({
  name: "SiteNavbar",

  setup() {
    const selectedLanguage = ref("English");

    const routes = useRouter().getRoutes();

    const languages = [
      { language: "English", shortLang: "en" },
      { language: "Español", shortLang: "es" },
      { language: "Français", shortLang: "fr" },
    ];

    const fontAwesomeStyling = ref(
      window.innerWidth < 600 ? "down-4" : "down-18"
    );
    const changeSelectedLanguage = (
      language: string,
      shorthand: "en" | "es" | "fr"
    ) => {
      selectedLanguage.value = language;
      i18n.global.locale = shorthand;
    };

    const showMenu = ref(false);
    const windowWidth = ref(window.innerWidth);

    window.onresize = () => {
      windowWidth.value = window.innerWidth;
      if (windowWidth.value < 768) showMenu.value = false;
      windowWidth.value < 600
        ? (fontAwesomeStyling.value = "down-4")
        : (fontAwesomeStyling.value = "down-18");
    };

    return {
      changeSelectedLanguage,
      fontAwesomeStyling,
      getImgUrl,
      languages,
      routes,
      selectedLanguage,
      showMenu,
      windowWidth,
    };
  },
});
